import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface SidebarPerformance extends SVGProps<SVGSVGElement> {
  label?: string
}

const SidebarPerformance: React.FC<SidebarPerformance> = ({
  label = 'sidebarPerformance',
  ...restProps
}) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="sidebar-performance-svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 13H8V21H2V13ZM9 3H15V21H9V3ZM16 8H22V21H16V8Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default SidebarPerformance
